import { envs } from '@ctct/infrastructure-layer';

import { useExtendedBillingAccount } from '../queries';
import { useIsSuspendedQuery } from '../queries/useIsSuspendedQuery';

export const useIsSuspendedFacade = () => {
  if (envs.isSecure()) {
    // hooks list will be stable per env, so we can safely disable the hooks rule
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data: billingAccount, isLoading, error } = useExtendedBillingAccount();

    return {
      data: billingAccount?.getIsSuspended() ?? false,
      isLoading,
      error,
    };
  }

  // hooks list will be stable per env, so we can safely disable the hooks rule
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { data: isSuspended, isLoading, error } = useIsSuspendedQuery();

  return {
    data: isSuspended ?? false,
    isLoading,
    error,
  };
};

export type UseIsSuspended = ReturnType<typeof useIsSuspendedFacade>;
